'use client';
import { Link } from '@/i18n/routing';
import { cn } from '@/shared/utils/cn';
import { AnchorHTMLAttributes, PropsWithChildren } from 'react';

type TextNavLinkProps = {
  href: string;
  onClick?: () => void;
  prefetch?: boolean;
  className?: string;
  ariaLabel?: string;
  isUnderline?: boolean;
  isBold?: boolean;
  target?: '_self' | '_blank' | '_parent' | '_top';
  rel?: string;
  unlocalized?: boolean;
};
export const TextNavLink = ({
  href,
  children,
  onClick,
  className,
  ariaLabel,
  isUnderline = false,
  isBold = false,
  prefetch = true,
  unlocalized = false,
  target,
  rel,
  ...rest
}: PropsWithChildren<
  TextNavLinkProps & Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href' | 'popover'>
>) => {
  const linkClassName = cn(
    'text-m transition-colors',
    'focus-visible:ring-primary lg:hover:text-text-hover focus:outline-hidden focus-visible:ring-2 focus-visible:ring-offset-2',
    isUnderline ? 'underline' : '',
    isBold ? 'font-semibold' : '',
    className,
  );

  if (unlocalized) {
    return (
      <a
        href={href}
        className={linkClassName}
        onClick={onClick}
        aria-label={ariaLabel}
        target={target}
        rel={rel}
        {...rest}
      >
        {children}
      </a>
    );
  }

  return (
    <Link
      href={href}
      prefetch={prefetch}
      className={linkClassName}
      onClick={onClick}
      aria-label={ariaLabel}
      target={target}
      rel={rel}
      {...rest}
    >
      {children}
    </Link>
  );
};
